import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useUser } from '../../../context';
import axios from 'axios';

const InviteRoute = () => {
  const { token } = useParams();
  const { user } = useUser();
  const navigate = useNavigate();
  const isAuthenticated = !!user;

  const isProfileComplete = user && user.name && user.email; // add more fields if they exist on IUser

  useEffect(() => {
    if (!user) {
      navigate(`/login?redirectTo=/invite/${token}`);
    } else {
      // Validate invite token with backend
      axios.get(`/invites/validate/${token}`).then(res => {
        // If profile incomplete, redirect to profile setup
        if (!isProfileComplete) {
          navigate('/profile-setup');
        } else {
          // Show application submission or dashboard
          navigate('/candidate-dashboard');
        }
      });
    }
  }, [user]);

  return null;
};

export default InviteRoute;
